import createApiClient from "./api";

const api = createApiClient();

export const uploadFile = async (projectId, formData, onProgress) => {
  const response = await api.post(
    `/files/upload?project_id=${projectId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      },
    }
  );
  return response.data;
};
